import { render, staticRenderFns } from "./SelectCloseBtn.vue?vue&type=template&id=359121c6&scoped=true&lang=pug"
var script = {}
import style0 from "./SelectCloseBtn.vue?vue&type=style&index=0&id=359121c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359121c6",
  null
  
)

export default component.exports